<header class="myHeader main_header clearfix" *ngIf="windowType === 'desktop'"
  [ngClass]="[isGamePage ? 'game-header': '', checkUserLoginStatus() ? 'show-timer':'']">
  <div class="header_container" [ngClass]="isUserLoggedIn ? 'userLogin':''">
    <div class="header_logo--section">
      <!-- Logo -->
      <a href="javascript:void(0);" class="main_header--logo" routerLink="{{langCode+'/'}}" (click)="goToTop()">
        <img src="{{siteUrlPath}}/{{mediaPath}}/common/{{websiteName}}-logo.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo" title="{{websiteName}}.com" />
      </a>
      <div class="main_header--tagLine">{{'headerComp.tagLine' | translate}}</div>
      <!-- Navigation to User info -->
      <div class="scroll--navUser">
        <div class="header_user-login">
          <!-- User info details -->
          <!-- (click)="balanceToggle()" -->
          <ul class="main_header--userNav main_header--userInfo" *ngIf="isUserLoggedIn===true">
            <li class="deposit" (click)="initialisePayment()" *ngIf="!userDetailsService.checkIsPNPUser()">
              <a class="site-btn site-btn--xm site-btn__primary" href="{{dynamicHrefPath+'?showDeposit=true'}}" (click)="preventDefaultAction($event)">
                <span>{{'headerComp.depositBtn' | translate}}</span>
              </a>
            </li>

            <li class="deposit" (click)="moveToTrustlyPay()" *ngIf="userDetailsService.checkIsPNPUser()">
              <a class="site-btn site-btn--xm site-btn__primary" href="{{dynamicHrefPath+'?showDeposit=true'}}" (click)="preventDefaultAction($event)">
                <span>{{'headerComp.depositBtn' | translate}}</span>
              </a>
            </li>

            <li class="dropdown">
              <div class="userIcon">
                <h4>{{'headerComp.balance' | translate}}</h4>
                <span class="user_amount"
                  *ngIf="(!isGamePage && !gameplayWindowMinimized) else hideCurrency;">
                  {{ userTotalBalance | currencyPipe}}
                 </span><br>
                <span class="bonus-box"
                  *ngIf="(!isGamePage && !gameplayWindowMinimized)">
                  {{ userBonusBalance | currencyPipe}}
                     {{'headerComp.headerBonus' | translate}}</span>

                <ng-template #hideCurrency>
                  <span class="user_game--dots">
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                  </span>
                </ng-template>

              </div>
            </li>

          </ul>

          <ul class="main_header--userNav" *ngIf="(isUserLoggedIn===undefined || isUserLoggedIn===false)">
            <ng-container *ngIf="(isCountryAllowed === 0 || isUserLoggedIn===undefined)">
              <li class="register">
                <a class="site-btn site-btn--xm site-btn__primary animated-background"
                  href="javascript:void(0);"><span></span></a>
              </li>
              <li class="register">
                <a class="site-btn site-btn--xm site-btn__primary animated-background"
                  href="javascript:void(0);"><span></span></a>
              </li>
            </ng-container>
            <ng-container *ngIf="isUserLoggedIn===false">
              <li class="register" (click)="moveToTrustlyPay()" *ngIf="isCountryAllowed === 1">
                <a class="site-btn site-btn--xm site-btn__primary"
                  href="{{dynamicHrefPath+'?showDeposit=true'}}" (click)="preventDefaultAction($event)"><span>{{'payandplay.deposit' | translate}}</span></a>
              </li>
             
              <li class="register" (click)="checkXSaleCondition()" *ngIf="isCountryAllowed === 2">
                <a class="site-btn site-btn--xm site-btn__primary"
                  href="{{langCode+'/register'}}" (click)="preventDefaultAction($event)"><span>{{'headerComp.registerBtn' | translate}}</span></a>
              </li>
              <li class="login" (click)="closeRegNavBar()">
                <a class="site-btn site-btn--xm site-btn__teritary-outline"
                routerLink="{{langCode+'/login'}}"><span>{{'headerComp.logInBtn' | translate}}</span></a>
              </li>
            </ng-container>
          </ul>

        </div>

        <div class="navigation">
          <!-- Main Navigation Links -->
          <div class="promo-link__section">
            <div *ngIf="!specialPromotions">
              <a class="animated-background main_header--menu-promoLink">
                <span></span>
                <span></span>
              </a>
              <a class="animated-background main_header--menu-promoLink">
                <span></span>
                <span></span>
              </a>
            </div>
            <a routerLink="{{langCode+'/'+specialPromo.url}}" *ngFor="let specialPromo of specialPromotions" class="main_header--menu-promoLink">
              <span class="">{{specialPromo.title}}</span>
            </a>
          </div>

          <button href="javascript:void(0)" type="button" class="main_header--menu-btn" (click)="openNavPanel()">
            <div class="main_header--menu-btn-icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span class="main_header--menu-btn-label">{{ 'headerComp.menu' | translate }}</span>
          </button>
          <!-- <app-timer *ngIf="checkUserLoginStatus()"></app-timer> -->
        </div>
      </div>
    </div>

    <div class="userinfo_chat">
      <div *ngIf="checkUserLoginStatus()" class="timer-section hide-below-992">
        <app-timer></app-timer>
      </div>
      <ul>
        <li *ngIf="isZendeskEnabled">
          <a href="javascript:void(0)" (click)="toggleZDChat()">
            <!-- <img src="/assets/img/chat-icon.png"> -->
            {{ 'headerComp.liveChat' | translate }}
          </a>
        </li>
        <li *ngIf="isTudiChatEnabled">
          <a href="javascript:void(0)" (click)="toggleTugiChat()">
            <!-- <img src="/assets/img/chat-icon.png"> -->
            {{ 'headerComp.liveChat' | translate }}
          </a>
        </li>
        <li>
          <a id="clock" class="clock"></a>
        </li>
      </ul>
    </div>
  </div>
</header>
<div class="addHeaderHeight"></div>


<!-- Left Toggle Registration  -->
<div class="reg_toggle" *ngIf="showRegNavBar">
  <div class="reg_toggle--container" [ngClass]="showRegNavBar ? 'show-Registration':'hide-Registration'" id="regtoggle"
    #regtoggle>
    <div class="overlay"></div>
    <div class="reg_toggle-content">
      <app-leftnav-registration [step]="registrationStep"></app-leftnav-registration>
    </div>
  </div>
</div>


<!-- Zimpler Left Toggle Menu -->
<div class="zimpler_toggle-menu">
  <div class="zimpler_profile--toggle" [ngClass]="isZimplerProfile ? 'show-profile':'hide-profile'" id="zimplerProfile" #zimplerProfile>
   <div class="zimpler_profile--content">
    <app-zimpler-complete-profile *ngIf='isZimplerProfile'></app-zimpler-complete-profile>
   </div>
  </div>
</div>

<!-- Mobile Navigation -->
<header class="main_header" *ngIf="windowType === 'mobile'">
  <div class="container-fluid">
    <a href="javascript:void(0)" class="main_header--logo" routerLink="{{langCode}}" (click)="goToTop()">
      <img src="/assets/img/{{websiteName}}-logo.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo" title="{{websiteName}}.com" />
    </a>
    <ul class="loginlist_menu main_header--mobMenu" *ngIf="!isUserLoggedIn">
      <li (click)="register()" class="no-content" *ngIf="isCountryAllowed === 2">
        <a id="headerHomeLink" class="menu-dropdown register" href="{{langCode+'/register'}}" (click)="preventDefaultAction($event)" title="Create Account">
          <span>{{'headerComp.createanAccount' | translate}}</span>
        </a>
      </li>
      <li (click)="moveToTrustlyPay()" *ngIf="isCountryAllowed === 1">
        <a id="headerHomeLink" class="menu-dropdown register" href="{{dynamicHrefPath+'?showDeposit=true'}}" (click)="preventDefaultAction($event)">
          <span>{{'payandplay.deposit' | translate}}</span>
        </a>
      </li>
    </ul>
    <ul class="loggedMobMenu main_header--mobMenu" *ngIf="isUserLoggedIn">
      <li (click)="initialisePayment()" class="no-content">
        <a id="headerHomeLink" class="menu-dropdown" href="{{dynamicHrefPath+'?showDeposit=true'}}" (click)="preventDefaultAction($event)" title="Deposit">
          <span>{{'headerComp.depositBtn' | translate}}</span>
        </a>
      </li>
      <li routerLink="{{langCode+'/myaccount'}}" class="no-content" (click)="goToTop()">
        <a id="headerHomeLink" class="menu-dropdown" href="{{langCode+'/myaccount'}}" (click)="preventDefaultAction($event)" title="My Account">
          <span>{{'headerComp.myAccount' | translate}}</span>
        </a>
      </li>
    </ul>
  </div>
</header>

<!-- PNP Merge Confirmation Modal -->
<modal id="mergeConfirmation" class="modal_smooth_open trustly_modal">
  <div class="fixed-scroll">
    <div class="site_modal middleAlignBlock">
      <div class="middleAlign">
        <div class="site_modal--body site_modal--body-small slideInDown">
          <div class="hidden-md hidden-lg mobile_modal_closeicon" (click)="closeModal('mergeConfirmation')"><i
              class="icon-close-simplified"></i></div>
          <div class="hidden-xs hidden-sm icon-cancel-svg" (click)="closeModal('mergeConfirmation')"></div>
          <div class="merge-success-wrap">
            <h4 class="headingtitle titlepadding">{{'payandplayMergeModal.title' | translate}}</h4>
            <p>{{'payandplayMergeModal.successContent' | translate}}</p>
            <p>{{'payandplayMergeModal.loginInfoContent' | translate}}</p>
            <div class="clearfix">
              <button type="button" class="startply-btn site-btn site-btn__primary site-btn--lg"
                (click)="closeModal('mergeConfirmation')">
                <span>{{'payandplayMergeModal.startplaying' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>

<!-- Sweden Regulation Modal for Registration -->
<modal id="restrict_reg_modal" class="modal_smooth_open sweden_modal" *ngIf="isSwedenJurisdictionShowNotification">
  <div class="fixed-scroll">
    <div class="site_modal middleAlignBlock">
      <div class="middleAlign">
        <div class="site_modal--body site_modal--body-small">
          <div class="hidden-md hidden-lg mobile_modal_closeicon" (click)="closeModal('restrict_reg_modal')"><i
              class="icon-close-simplified"></i></div>
          <div class="hidden-xs hidden-sm icon-cancel-svg" (click)="closeModal('restrict_reg_modal')"></div>
          <div class="reg_disable_wrap">
            <h4 class="headingtitle titlepadding">Vår ansökan för den svenska spellicensen är under behandling. Fram
              tills godkännande är Registrering, Insättning och Spel blockerat.</h4>
            <div class="clearfix">
              <button type="button" class="reg_disable_btn site-btn site-btn__primary site-btn--lg"
                routerLink="{{langCode+'/page/swedish-regulation-faq'}}" (click)="closeModal('restrict_reg_modal')">
                <span>Läs mer här</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>

<!-- Deposit Modal Initialise -->
<app-hosted-cashier *ngIf="paymentInitialise" [cashierType]="cashierType"></app-hosted-cashier>
<app-pending-withdrawal-modal *ngIf="showPendingWithdrawl"></app-pending-withdrawal-modal>
<app-deposit-popup *ngIf="pnpDepositInitialise"></app-deposit-popup>

<!-- Quick login -->
<div id="quickLogin" class="modal_smooth_open fixed-scroll quick_login" *ngIf="openQuickLoginModal">
  <div class="site_modal middleAlignBlock">
    <div class="middleAlign">
      <div class="site_modal--body site_modal--body-small">
        <div class="hidden-xs hidden-sm icon-cancel-svg" (click)="closeQuickLogin()"></div>
        <!-- Quick_login logo block -->
        <div class="quick_login--logo">
          <img (click)="closeQuickLogin()" src="/assets/img/{{websiteName}}-logo.{{websiteLogoExtension}}" />
        </div>
        <app-loginform></app-loginform>
      </div>
    </div>
  </div>
</div>


<ng-container *ngIf="windowType === 'mobile'">
  <app-slot-game-modal ></app-slot-game-modal> 
</ng-container>
<!-- <app-slot-game-modal></app-slot-game-modal> -->


<!-- Hosted Cashier Notification -->
<!-- <div class="hosted__cashier--notification" *ngIf="isShowDepositPending && isUserLoggedIn">
  <div class="notification_progress">
    <span class="progress"></span>
</div>
    <div class="hosted__cashier--notification--left">
      <img src="{{siteUrlPath}}/{{mediaPath}}/crypto_logo/crypto_coin-dsk.png" class="hide-below-992"/>
      <img src="{{siteUrlPath}}/{{mediaPath}}/crypto_logo/crypto_coin-mob.png" class="show-below-992"/>
    </div>
    <div class="hosted__cashier--notification--right">
      <h2>{{'cryptoCashier.depositPendingNotification' | translate}}</h2>
      <p>
        {{'cryptoCashier.depositPendingConfirmation' | translate}}
      </p>
    </div>
</div> -->
<app-juridiction-modal></app-juridiction-modal>
<!-- <app-x-sale-modal></app-x-sale-modal> -->
<app-custom-cashier *ngIf="isShowCashier"></app-custom-cashier>
<ng-template #containerRefFF></ng-template>
